import API, { responseOf } from "./base";
import type {
  AccountType,
  AccountTypeAffinityDto,
  AccountTypeRoleUserDtoResponse,
} from "../model/AccountType";
import type FieldDefinition from "../model/FieldDefinition";

export const get = (id: string): Promise<AccountType> =>
  responseOf(API.get(`/account-types/${id}`, { public: true }));

export const create = (accountType: AccountType): Promise<AccountType> =>
  responseOf(API.post("/account-types", accountType));

const deleteAccountType = async (accountTypeId: string): Promise<void> => {
  await API.delete(`/account-types/${accountTypeId}`);
};
export { deleteAccountType as delete };

export const update = (accountType: AccountType): Promise<AccountType> =>
  responseOf(API.put(`/account-types/${accountType.id}`, accountType));

export const byOrganizationId = (
  organizationId: string,
): Promise<AccountType[]> =>
  responseOf(
    API.get(`/account-types/byOrganizationId/${organizationId}`, {
      public: true,
    }),
  );

export const byKey = (
  organizationId: string,
  accountTypeKey: string,
): Promise<AccountType> =>
  responseOf(
    API.get(
      `/account-types/byOrganizationId/${organizationId}/byKey/${accountTypeKey}`,
      { public: true },
    ),
  );

export const getAffinity = (
  accountId: string,
): Promise<AccountTypeAffinityDto> =>
  responseOf(API.get(`/account-types/${accountId}/affinity`));

export const listAccountTypeRoles = (
  accountTypeId: string,
): Promise<AccountTypeRoleUserDtoResponse[]> =>
  responseOf(API.get(`/account-types/listAccountTypeRoles/${accountTypeId}`));

export const reassignAccountTypeRole = async (
  accountTypeId: string,
  roleId: string,
  userId?: string,
): Promise<void> => {
  await API.post("/account-types/reassignAccountTypeRole", {
    accountTypeId,
    roleId,
    userId,
  });
};

export const getFieldDefinitions = (
  accountTypeId: string,
): Promise<{
  selected: string[];
  available: Record<string, FieldDefinition>;
}> => responseOf(API.get(`/account-types/${accountTypeId}/fields`));

export const addSelectedFieldDefinition = async (
  accountTypeId: string,
  fieldDefinitionId: string,
): Promise<void> => {
  await API.post(`/account-types/${accountTypeId}/fields/${fieldDefinitionId}`);
};

export const removeSelectedFieldDefinition = async (
  accountTypeId: string,
  fieldDefinitionId: string,
): Promise<void> => {
  await API.delete(
    `/account-types/${accountTypeId}/fields/${fieldDefinitionId}`,
  );
};

export const setSelectedFieldDefinitions = async (
  accountTypeId: string,
  fieldDefinitionIds: string[],
): Promise<void> => {
  await API.put(`/account-types/${accountTypeId}/fields`, fieldDefinitionIds);
};
